module.exports = __webpack_public_path__ + "img/diners.7ca4a93b.svg";